export default "__VITE_ASSET__Bu_H6DoZ__"